import { gql } from 'graphql-tag';

// Mutation to start the purchases export job
export const EXPORT_PURCHASES = gql`
  mutation GetAccountPurchasesReport($input: AccountPurchasesExportInput!) {
    getAccountPurchasesReport(input: $input) {
      jobId
      message
    }
  }
`;

// Subscription to track export status
export const PURCHASES_EXPORT_STATUS = gql`
  subscription AccountPurchasesExportStatus($jobId: String!) {
    accountPurchasesExportStatus(jobId: $jobId) {
      jobId
      status
      progress
      filename
      recordCount
      error
    }
  }
`;

// Query to get download URL when complete
export const GET_PURCHASES_EXPORT_DOWNLOAD_URL = gql`
  query GetAccountPurchasesExportDownloadUrl($jobId: String!) {
    getAccountPurchasesExportDownloadUrl(jobId: $jobId)
  }
`;
